import auth from '@/auth/auth'
import { clearIndexedDB } from '@/utils/utils'

const checkToken = async ({commit}) => {
  const user = await auth.checkToken(window.location.hash)
  commit('SET_ACCESS_TOKEN')
  commit('SET_USER', user)
}

const clearToken = async ({rootState, commit}) => {
  // add token to logoutUrl
  const redirectUrl =  `${auth.logoutUrl}&access_token=${encodeURIComponent(rootState.user.accessToken)}`

  commit('CLEAR_ACCESS_TOKEN')
  commit('CLEAR_USER')

  try {
    await clearIndexedDB()
  }
  catch (err) {
    // pass
  }

  localStorage.removeItem('unAuthLastViewedURL')

  auth.logout(redirectUrl)
}

export default {
  checkToken,
  clearToken
}
